// Angular
import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

// Angular Material
import { MatDialog } from '@angular/material/dialog';

// localforage
import * as localforage from 'localforage';

// services
import { DrawerService } from '@app/services/drawer/drawer.service';
import { ApiService } from '@app/services/api/api.service';

@Component({
  selector: 'go-to-admin-dashboard',
  templateUrl: './go-to-admin-dashboard.component.html',
  styleUrls: ['./go-to-admin-dashboard.component.scss'],
})
export class GoToAdminDashboardComponent implements OnInit {

  private agentData: any;
  public form: FormGroup;
  public isOnline: boolean;
  public loginError: any;
  public loading: boolean;

  constructor(private router: Router, 
    private dialog: MatDialog, 
    private drawerService: DrawerService,
    fb: FormBuilder, private apiService: ApiService
    ) {
      this.form = fb.group({
        password: ['', Validators.required],
      });
    }

    ngOnInit() {
      this.isOnline = navigator.onLine;
      this.getData();
    }

    get valid() {
      return this.form.valid;
    }

    get value() {
      const formValue = this.form.value;
      formValue.username = this.agentData.uid;
      return formValue;
    }

    private async getData() {
      try {
        this.agentData = await this.apiService.getAgentDataFromDatabase();
      } catch (error) {
        console.log(error);
      }
    }

    public async login() {
      this.isOnline = navigator.onLine;
      this.loginError = null;
      this.loading = true;
  
      try {        
        const response = await this.apiService.login(this.value);
        if(response.status === "ok"){
          await localforage.removeItem('oh-active-user');
          this.drawerService.dismiss();
          this.dialog.closeAll();
          this.router.navigate(['/admin-dashboard']);
        }
      } catch (error) {
        this.handleError(error);
      }
  
      this.loading = false;
    }

  private handleError(error: any) {
    if (error && error.error && error.error.message) {
      this.loginError = error.error.message;
    } else {
      console.log(error);
    }

    if (this.isOnline === false) {
      this.loginError = 'You must be online to access the admin dashboard.';
    }
  }

  public cancel() {
    this.dialog.closeAll();
  }
}
